import { render } from "./RePassword.vue?vue&type=template&id=f3b3e4e4&scoped=true"
import script from "./RePassword.vue?vue&type=script&lang=js"
export * from "./RePassword.vue?vue&type=script&lang=js"

import "./RePassword.vue?vue&type=style&index=0&id=f3b3e4e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b3e4e4"]])

export default __exports__